import { Image } from "@/components/Image";
import { ArrowRight } from "@/components/icons/ArrowRight";
import { dayjs } from "@/lib/dayjs";
import clsx from "clsx";
import Link from "next/link";
import { SecondaryButton } from "ui/components";
import type { ReplayYurplanConferences } from "../../getReplayYurplanConferences";

type Props = {
  conference: ReplayYurplanConferences["conferences"][number];
};
export const ConferenceSolo = ({ conference }: Props) => {
  const speaker = conference.speaker;

  return (
    <div className="flex flex-col lg:flex-row">
      <div className="lg:w-[216px] shrink-0 lg:mr-4 max-lg:mb-4 max-lg:group-[.cycle-open]:hidden">
        {conference.coverUrl && (
          <img className="w-full text-transparent object-cover aspect-video" src={conference.coverUrl} alt="" />
        )}
      </div>
      <div className="flex flex-col gap-2 lg:gap-3 justify-center grow lg:mr-12 max-lg:mb-3 max-lg:group-[.cycle-open]:mb-0">
        <p className="text-xs text-[#6D6662] max-lg:group-[.cycle-open]:hidden">
          {dayjs(conference.dateStart).format("DD MMM YYYY")}
        </p>
        <p className="text-[#FCF6F0] text-xl leading-6 font-semibold line-clamp-2 lg:line-clamp-1 lg:h-6">
          {conference.title}
        </p>
        <p className="text-[#FCF6F0] text-base font-light line-clamp-2 h-12 max-lg:group-[.cycle-open]:hidden">
          {conference.description}
        </p>
      </div>
      <div
        className={clsx("shrink-0 flex flex-col max-lg:group-[.cycle-open]:hidden", {
          "justify-between": speaker,
          "justify-end": !speaker,
        })}
      >
        {speaker && (
          <div className="flex gap-2 max-lg:mb-3">
            <div className="w-12 h-12 rounded-full overflow-hidden">
              <Image
                image={{
                  type: "speaker",
                  id: speaker.id.toString(),
                  name: speaker.imageName || "",
                  realname: speaker.imageRealname || "",
                }}
                sizes="144px"
                alt={`${speaker.firstname} ${speaker.lastname}`}
                height={{
                  type: "ratio",
                  value: 100,
                }}
              />
            </div>
            <div>
              <p className="text-[#C1B1AC] text-xs">Animée par</p>
              <p className="text-[#FCF6F0] text-base leading-5 font-medium">{`${speaker.firstname} ${speaker.lastname}`}</p>
            </div>
          </div>
        )}
        <Link href={`/conferenciers/conference/y-${conference.id}-${conference.slug}`}>
          <SecondaryButton>
            Accéder ({conference.price}€) <ArrowRight />
          </SecondaryButton>
        </Link>
      </div>
    </div>
  );
};
